<script setup lang="ts">
defineProps<{
  resource: number
  isHideTip?: boolean
  privilege: { icon: string, name: string, desc: string }[]
}>()
const { locale } = useI18n()
</script>

<template>
  <div flex flex-wrap justify-center gap-x-24 gap-y-10>
    <div
      v-for="(item) in privilege"
      :key="item.name"
      class="flex flex-col items-center gap-4"
      :class="locale === 'pt' ? 'w-[calc(50%-14px)]' : 'max-w-100 min-w-72'"
    >
      <div class="g-vip__icon mb-4 h-40 w-40 flex items-center justify-center rd-full">
        <img :src="item.icon" class="h-24 w-24">
      </div>
      <div class="text-13 text-[--color-text-2] font-500 ellipsis">
        {{ $t(item.name) }}
      </div>
      <div v-if="!isHideTip" class="text-12 text-[--color-text-4] ellipsis">
        {{ $t(item.desc) }}
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.g-vip__icon {
  background: linear-gradient(239deg, rgba(255, 255, 255, 0.00) -40.17%, rgba(233, 225, 255, 0.50) 100%), rgba(255, 255, 255, 0.40);
  box-shadow: 0px 4px 8px 0px #FFF inset, 0px 0px 4px 0px #FFF inset;
  backdrop-filter: blur(2px);
}
</style>
